import * as React from 'react';
import './styles.scss';
import { ErrorInfo } from 'react';

interface IErrorProps {
  errorInfo?: ErrorInfo;
  error?: Error;
}
export const ErrorFallback: React.FunctionComponent<IErrorProps> = ({
  errorInfo,
  error
}: IErrorProps) => (
  <div>
    <p>
      <strong>Oops! An error occured!</strong>
    </p>
    <p>Here’s what we know…</p>
    <p>
      <strong>Error:</strong> {(error || '').toString()}
    </p>
    <p>
      <strong>Stacktrace:</strong> {(errorInfo || '').toString()}
    </p>
  </div>
);
